import React, { useState, useRef } from "react";
import "./../styles/HalfBox.css";
import { HeaderTitle } from "./HeaderTitle";
import { FieldGroup } from "./FieldGroup";
import { TaskDetailsBox } from "./TaskDetailsBox";
import { DecisionBox } from "./DecisionBox";
import SendSelectedText from "../SendSelectedText";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { useEffect } from "react";
import PdfViewer from "../../pages/PdfViewer";
import { Grid } from "@mui/material";
import { Box } from "@mui/system";

const eTYPE = ["form-fields", "document-viewer"];

export const HalfBox = (props) => {
  const [newEntry, setNewEntry] = useState([]);
  console.log("Halfbox new entry", newEntry);
  const [loader, setLoader] = useState(true);
  const [confidenceCheck, setConfidenceCheck] = useState(true);
  const [mandatoryCheck, setMandatoryCheck] = useState(false);

  const [dataStatus, setDataStatus] = useState(true);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [showCanvas, setShowCanvas] = useState(false);
  const [selectedField, setSelectedField] = useState("");
  const [callValidateAPI, setCallValidateAPI] = useState(false);
  const [imageDimension, setImageDimension] = useState({ height: 0, width: 0 });
  const [resultBoxVisibility, setresultBoxVisibility] = useState("");

  useEffect(() => {
    console.log("value for percentage ", props.ocrData.Confidence);
    setTimeout(() => {
      setLoader(false);
    }, 5000);
  }, []);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const getHeightAndWidthOfElement = (elementId) => {
    let element = document.getElementById(elementId);
    if (!element) {
      return {
        width: 0,
        height: 0,
      };
    }
    return {
      width: element.getBoundingClientRect().width,
      height: element.getBoundingClientRect().height,
    };
  };

  const confidenceChecked = (e) => {
    const checked = e.target.checked;
    if (checked) {
      setConfidenceCheck(true);
    } else {
      setConfidenceCheck(false);
    }
  };

  const mandatoryChecked = (e) => {
    const checked = e.target.checked;
    if (checked) {
      setMandatoryCheck(true);
    } else {
      setMandatoryCheck(false);
    }
  };

  function handleBodyClick(e) {
    //e.preventDefault();
    var activeElement = document.activeElement;
    //console.log(document.activeElement.className);
    var inputs = [
      "txtMemberID_CR",
      "txtDateOfBirth_DT",
      "txtFirstName_CR",
      "txtLastName_CR",
      "txtRequestorName_CR",
      "txtRequestorContactNo_CR",
      "txtRequestorFaxNo_CR",
      "txtAdditionalMessage_CR",
      "txttxtServiceRequestDate_DT",
      "txtAnticipatedStart",
      "txttxtAnticipatedEnd",
      "txtAnticipatedStartDate_DT",
    ];

    if (activeElement && inputs.indexOf(activeElement.id) !== -1) {
      return;
    }

    var result = document.getElementById("myresult");
    var lens = document.getElementById("highlightbox");
    result.style.display = "none";
    lens.style.display = "none";
    return;
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <TaskDetailsBox
            taskData={props.taskData}
            ocrData={props.ocrData}
            taskStatus={props.taskStatus}
            maxConfidence={props.ocrData.Confidence}
            authId={props.authId}
          ></TaskDetailsBox>
        </Grid>
        <Grid item xl={7} lg={7} md={7} sm={12} xs={12} className="flexbox-h6">
          <div class="left-box-container">
            {/* {loader ? (
              <Box className="loader-wrapper loader-fax-wrapper">
                <div className="loader"></div>
              </Box>
            ) : (
              ""
            )} */}

            <FieldGroup
              newEntry={newEntry}
              setNewEntry={setNewEntry}
              contentType="fields"
              fieldGroup="pdf_box"
              pdfImg={props.fax.body.Fax_URL}
              pdfUrl={props.fax.body.Fax_PDF_URL}
              setShowCanvas={setShowCanvas}
              showCanvas={showCanvas}
              selectedField={selectedField}
              setCallValidateAPI={setCallValidateAPI}
              getOCRDatafromAPI={props.getOCRDatafromAPI}
              imageDimension={imageDimension}
              setImageDimension={setImageDimension}
            ></FieldGroup>
          </div>
        </Grid>
        <Grid item xl={5} lg={5} md={5} sm={12} xs={12} className="flexbox-h6">
          <div className="box-half">
            <Box className="halfbox-checkbox-wrapper">
              <div className="box-header">
                <HeaderTitle
                  divStyle="header-div--sub"
                  headerStyle="header--sub"
                  headerSize="header--small"
                  divAlign="header--left"
                  textContent="Extracted Data"
                ></HeaderTitle>
              </div>
              <FormControlLabel
                className="confidence-checkbox-box"
                control={
                  <Checkbox
                    // defaultChecked
                    size="small"
                    onClick={(e) => mandatoryChecked(e)}
                  />
                }
                label="Show Optional Fields"
              />
              <FormControlLabel
                className="confidence-checkbox-box"
                control={
                  <Checkbox
                    defaultChecked
                    size="small"
                    onClick={(e) => confidenceChecked(e)}
                  />
                }
                // label="Show Confidence Level"
                label="Show Completion Status"
              />
            </Box>

            {/* <SendSelectedText /> */}
            <div className="halfbox-content-new" onClick={handleBodyClick}>
              <div className="box-content">
                <FieldGroup
                  newEntry={newEntry}
                  setNewEntry={setNewEntry}
                  contentType="fields"
                  headerTitle="Validation"
                  fieldGroup="validation"
                  ocrData={props.ocrData}
                  confidenceCheck={confidenceCheck}
                  resultBoxVisibility={resultBoxVisibility}
                ></FieldGroup>
                <FieldGroup
                  newEntry={newEntry}
                  setNewEntry={setNewEntry}
                  contentType="fields"
                  // headerTitle="Member Information"
                  fieldGroup="common_information"
                  pdfImg={props.fax.body.Fax_URL}
                  ocrData={props.ocrData}
                  coords={props.coords}
                  setterMethod={props.setOCRData}
                  confidenceCheck={confidenceCheck}
                  dxData={props.dxData}
                  setDXData={props.setDXData}
                  cptData={props.cptData}
                  setCPTData={props.setCPTData}
                  umReviewTypeCB={props.umReviewTypeCB}
                  admissionSourceCB={props.admissionSourceCB}
                  requestProfileCB={props.requestProfileCB}
                  admissionTypeCB={props.admissionTypeCB}
                  selectedUMreviewType={props.selectedUMreviewType}
                  setUMReviewTypeSelected={props.setUMReviewTypeSelected}
                  selectedAdmissionSource={props.selectedAdmissionSource}
                  setAdmissionSourceSelected={props.setAdmissionSourceSelected}
                  selectedAdmissionType={props.selectedAdmissionType}
                  setAdmissionTypeSelected={props.setAdmissionTypeSelected}
                  selectedRequestProfile={props.selectedRequestProfile}
                  setSelectedRequestProfile={props.setSelectedRequestProfile}
                  selectedUMReviewTypeData={props.selectedUMReviewTypeData}
                  requestProfileData={props.requestProfileData}
                  providerData={props.providerData}
                  setProviderData={props.setProviderData}
                  mandatoryCheck={mandatoryCheck}
                  taskStatus={props.taskStatus}
                  getOCRDatafromAPI={props.getOCRDatafromAPI}
                  setDataStatus={setDataStatus}
                  setShowCanvas={setShowCanvas}
                  setSelectedField={setSelectedField}
                  imageDimension={imageDimension}
                  setImageDimension={setImageDimension}
                  maxConfidence={props.ocrData.Confidence}
                ></FieldGroup>
              </div>
              <div className="box-footer">
                <DecisionBox
                  ocrData={props.ocrData}
                  taskData={props.taskData}
                  selectedUMreviewType={props.selectedUMreviewType}
                  selectedAdmissionSource={props.selectedAdmissionSource}
                  selectedAdmissionType={props.selectedAdmissionType}
                  selectedRequestProfile={props.selectedRequestProfile}
                  dxData={props.dxData}
                  cptData={props.cptData}
                  providerData={props.providerData}
                  isLoading={props.isLoading}
                  setLoading={props.setLoading}
                  taskStatus={props.taskStatus}
                  completedTime={props.completedTime}
                  getOCRDatafromAPI={props.getOCRDatafromAPI}
                  dataStatus={dataStatus}
                ></DecisionBox>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  );
};
